import { fetchStage } from './stageSlice';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { setCurrentProfile } from './profileSlice';
import {
	upsertProfileVerificationStatusThunk,
	upsertProfileThunk,
} from './sessionSlice';

export const startVerificationThunk = createAsyncThunk(
	'verification/startVerification',
	async (
		{
			token,
			profile,
			stages,
			type,
			confirmationNo,
		}: {
			token: string;
			profile: any;
			stages: any;
			type: string;
			confirmationNo: string;
		},
		{ dispatch }
	) => {
		console.log('reached startVerificationThunk');

		const currentProfile = profile;

		if (currentProfile?.profileID === 0) {
			console.log('Profile ID is 0, calling upsertProfileThunk first');
			try {
				const upsertRes: any = await dispatch(
					upsertProfileThunk({ token, profile: currentProfile })
				).unwrap();
				console.log('upsertProfileThunk response:', upsertRes);
				if (upsertRes && upsertRes.result && upsertRes.data) {
					currentProfile.profileID = upsertRes.data;
				}
			} catch (err) {
				console.error('Failed to create profile before verification:', err);
			}
		}

		// 1️⃣ upsert profile
		return dispatch(
			upsertProfileVerificationStatusThunk({ token, profile: currentProfile })
		)
			.unwrap()
			.then((res: any) => {
				console.log('Profile upserted, response:', res);
				const finalProfile = res?.data ?? currentProfile;

				if (res && res.result) {
					console.log('Profile upserted successfully');
					// 2️⃣ set current profile
					dispatch(setCurrentProfile(finalProfile));

					// 3️⃣ fetch stage using returned profileID
					console.log('fetch stage using returned profileID');

					dispatch(
						fetchStage({
							token,
							type,
							confirmationNo,
							stages,
							profileID: finalProfile.profileID,
						})
					);
					return finalProfile;
				} else {
					console.error('Failed to upsert profile verification status');
					// Optionally, you can throw an error here to be caught by the caller
					// throw new Error('Failed to upsert profile verification status');
				}
			});
	}
);
